import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BASE_URL } from './base-url';

@Injectable({
  providedIn: 'root'
})
export class ServiceProvidersService {

  constructor(public http: HttpClient) { }

  base_URL = BASE_URL;

  getAllServiceProviders() {
    return this.http.get(`${this.base_URL}serviceProviders/all`);
  }

  getServiceProviderById(serviceProvidersId: any) {
    return this.http.get(`${this.base_URL}serviceProviders/${serviceProvidersId}`);
  }

  addServiceProvider(serviceProvider: any) {
    return this.http.post(`${this.base_URL}serviceProviders`, serviceProvider);
  }

  updateServiceProvider(serviceProvider: any) {
    return this.http.put(`${this.base_URL}serviceProviders/update`, serviceProvider);
  }

  deleteServiceProvider(serviceProvidersId: any) {
    return this.http.delete(`${this.base_URL}serviceProviders/hardDelete/${serviceProvidersId}`);
  }

  softDeleteServiceProvider(serviceProvidersId: any) {
    return this.http.delete(`${this.base_URL}serviceProviders/softDelete/${serviceProvidersId}`);
  }

  getServiceProviderByWildSearch(wildSearch: any) {
    return this.http.get(`${this.base_URL}serviceProviders/wildSearch/${wildSearch}`);
  }
}
